export const handbookCopy = {
  handb_prev: "上一篇",
  handb_next: "下一篇",
}
